import {
  useGetFormulaComponentItemIngredientsQuery,
  useLinkIngredientToFormulaComponentItemMutation,
  useRemoveFormulaComponentItemIngredientMutation,
  useUpdateFormulaComponentItemIngredientMutation,
} from "@/redux/services/inventory/recipe.api";
import RecipeIngredientsManager from "./RecipeIngredientsManager";
import { usePermissions } from "@/hooks/usePermissions";
import { recipeMutationResult } from "./recipeMutationResult";

interface FormulaComponentItemIngredientsProps {
  componentItemId: string;
  restaurantId: string;
}

const FormulaComponentItemIngredients = ({
  componentItemId,
  restaurantId,
}: FormulaComponentItemIngredientsProps) => {
  // Recipes are read with inventory.view and written with inventory.manage.
  const { canManage } = usePermissions();
  const { data, isLoading } = useGetFormulaComponentItemIngredientsQuery({
    componentItemUuid: componentItemId,
  });
  const [link, { isLoading: isLinking }] =
    useLinkIngredientToFormulaComponentItemMutation();
  const [remove] = useRemoveFormulaComponentItemIngredientMutation();
  const [update, { isLoading: isUpdating }] =
    useUpdateFormulaComponentItemIngredientMutation();

  return (
    <RecipeIngredientsManager
      readOnly={!canManage("inventory")}
      restaurantId={restaurantId}
      linkedIngredients={data?.results ?? []}
      isLoading={isLoading}
      isLinking={isLinking}
      isUpdating={isUpdating}
      emptyTitle="Aucun ingrédient lié à cet élément"
      emptySubtitle="Ajoutez des ingrédients pour suivre la consommation lorsqu'il est sélectionné dans une formule."
      onLink={async (payload) => {
        const res = await link({
          componentItemUuid: componentItemId,
          data: payload,
        });
        // The picker only offers ingredients not linked yet, so a duplicate
        // is not expected here; any refusal goes through the shared helper.
        return recipeMutationResult(res, "Erreur lors de la liaison");
      }}
      onRemove={async (mapping) => {
        const res = await remove({
          componentItemUuid: componentItemId,
          mappingUuid: mapping.id,
        });
        return recipeMutationResult(res, "Erreur lors de la suppression");
      }}
      onUpdate={async (mapping, args) => {
        const res = await update({
          componentItemUuid: componentItemId,
          mappingUuid: mapping.id,
          data: args,
        });
        return recipeMutationResult(res, "Erreur lors de la mise à jour");
      }}
    />
  );
};

export default FormulaComponentItemIngredients;
